import React, { useState } from 'react'
import ArrowUp from '../../../assets/icons/ArrowUp'
import ArrowDown from '../../../assets/icons/ArrowDown'

interface AccordionProps {
  title: string
  content: string
  isOpen: boolean
  onClick: () => void
}

const Accordion: React.FC<AccordionProps> = ({ title, content, isOpen, onClick }) => {
  return (
    <div className="bg-[#F8F9FA] rounded-lg pr-10 pl-4">
      <div
        onClick={onClick}
        className="cursor-pointer flex justify-between items-center py-4 "
      >
        <h3 className=" text-sm md:text-lg font-medium">{title}</h3>
        <span className="w-4 h-4 md:w-6 md:h-6">
          {isOpen ? <ArrowUp /> : <ArrowDown />}
        </span>
      </div>
      {isOpen && (
        <div className="py-2 text-[#6C757D] text-sm md:text-base">
          <p className="w-full break-words">{content}</p>
        </div>
      )}
    </div>
  )
}

export default Accordion
